import Image from "next/image";
import services3Data from "../../../data/sections/services3.json";
import Link from "next/link";

const AboutExperts = () => {

  return (
    <section className='services service-border section-padding'>
      <div className='container'>
        <div className='row row-gap-2'>
          <div className='col-lg-4 custom-export-section d-flex  justify-content-center align-items-center'>
            <div className={`d-flex flex-column call-action custom-font-size justify-content-center align-items-center w-92 wow fadeInUp`} data-wow-delay='.3s'>
              <div className='col-md-12 call-action col-lg-12'>
                <div className='content sm-mb30'>
                    <h2 className='custom-font customTitle'>
                      Dedicated Developers May  <b> Support Your Business</b>.
                    </h2>
                </div>
              </div>
              <Link href={`/quote/expert?id=${btoa('expert-Home')}`}>
                <a className='btn-curve btn-bord btn-lit mt-40'>
                  <span>Talk to Our Expert</span>
                </a>
              </Link>
            </div>
          </div>
          {services3Data.map((item, index) => (
            <div className='col-sm-6 col-lg-4' key={item.id}>
              <div className={`item h-100 text-left p-40 ${index != services3Data.length - 1 ? "md-mb50" : ""} wow fadeInUp`}
                data-wow-delay='.3s' >
                {/* <span className={`icon`}> */}
                  <Image
                    src={`https://settingsinfotech.s3.ap-south-1.amazonaws.com/si/common/${item.icon}.svg`}
                    alt={item.icon}
                    width={80}
                    height={80}
                  />
                {/* </span> */}
                <h3>{item.title}</h3>
                <p>{item.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutExperts;
